import { checkIfTranscriptionGenerating } from '@frameio/shared/components/GenerateTranscriptionForm';
import type { TranscriptionLike } from '@frameio/shared/components/GenerateTranscriptionForm/transcriptionUtils';
import type { useTranscriptionEncodeStatusFragment } from '../../shared/gql/generated/TranscriptionEncodeStatus';
import type { AssetState } from '../types';

export function getStateForTranscribing(
  transcriptionData: ReturnType<typeof useTranscriptionEncodeStatusFragment>
): AssetState | undefined {
  const asset = transcriptionData.data;

  if (!asset) return undefined;
  if (asset.__typename !== 'AudioAsset' && asset.__typename !== 'VideoAsset') {
    return undefined;
  }

  if (
    !('localeTranscriptions' in asset) ||
    !asset.localeTranscriptions ||
    !asset.localeTranscriptions?.nodes
  ) {
    return undefined;
  }

  const transcriptionNodes = asset.localeTranscriptions
    .nodes as TranscriptionLike[];

  const isGenerating = checkIfTranscriptionGenerating(transcriptionNodes);

  if (!isGenerating) return undefined;

  const latestTranscription = transcriptionNodes.find(
    (node) => node?.encodeStatus === 'STARTED'
  );
  const source = latestTranscription?.source ?? 'GENERATED';

  if (source === 'UPLOAD') {
    return 'transcribing-processing';
  }

  return 'transcribing';
}
